import { CategoryWiseProductsResponse } from '@/types/Category';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type CategoryDetails = {
  categoryDetails?: CategoryWiseProductsResponse;
};

const initialState = {
  categoryDetails: undefined,
} as CategoryDetails;

const categoryDetails = createSlice({
  name: 'categoryDetails',
  initialState,
  reducers: {
    setCategoryDetails(state, { payload: details }: PayloadAction<CategoryWiseProductsResponse>) {
      state.categoryDetails = details;
    },
  },
});

export const { setCategoryDetails } = categoryDetails.actions;
export default categoryDetails;
